import { get } from '@rails/request.js';

import FormController from '@controllers/portal/components/form_controller';

export default class extends FormController {
  
  static targets = ['optionSetItem', 'positionField'];
  
    moveOptionUp(e) {
    console.log('moveOptionUp called');
    const optionSetId = e.currentTarget.dataset.optionSetId;
    const currentItem = this.findOptionItem(optionSetId);
    const previousItem = currentItem.previousElementSibling;

    if (previousItem) {
      currentItem.parentNode.insertBefore(currentItem, previousItem);
    } else {
      currentItem.parentNode.appendChild(currentItem);
    }
    
    this.updateAllPositions();
  }

  moveOptionDown(e) {
    const optionSetId = e.currentTarget.dataset.optionSetId;
    const currentItem = this.findOptionItem(optionSetId);
    const nextItem = currentItem.nextElementSibling;
    
    if (nextItem) {
      currentItem.parentNode.insertBefore(currentItem, nextItem.nextElementSibling);
    } else {
      currentItem.parentNode.insertBefore(currentItem, currentItem.parentNode.firstChild);
    }
    
    this.updateAllPositions();
  }
  
  findOptionItem(optionSetId) {
    return this.optionSetItemTargets.find(item => item.dataset.optionSetId === optionSetId);
  }

  updateAllPositions() {
    this.optionSetItemTargets.forEach((item, index) => {
      const newPosition = index + 1;
      const optionSetId = item.dataset.optionSetId;
      const positionField = this.positionFieldTargets.find(field => field.dataset.optionSetId === optionSetId);  // ← Fixed property
      
      if (positionField) {
        positionField.value = newPosition;
      }
    });
  }
}
